<template>
    <Motion
      :initial="{ opacity: 0, scale: 0.95 }"
      :animate="{ opacity: 1, scale: 1 }"
      :transition="{ duration: 0.5, delay: 0.2, type: 'spring', stiffness: 100 }"
    >
      <div class="bg-white/70 rounded-xl p-4 sm:p-6 md:p-8 shadow-md">
        <div class="max-w-2xl mx-auto text-center px-4">
          <div class="flex items-center justify-center gap-2 mb-4">
            <div class="flex-shrink-0 w-10 h-10 bg-yellow-500/20 rounded-full flex items-center justify-center">
              <v-icon color="yellow">mdi-share-variant</v-icon>
            </div>
            <h2 class="text-2xl font-bold text-slate-800">Share Your Discovery</h2>
          </div>
          
          <p class="text-gray-700  mb-6 max-w-xl mx-auto text-sm sm:text-base">
            Snap a photo of your duck discovery and share it on the dedicated Facebook Group. 
            Join the duck-finding community and see where others have found their ducks!
          </p>
          
          <button 
            @click="$emit('share')" 
            class="px-4 sm:px-6 py-3 bg-yellow-500 hover:bg-yellow-600 text-white rounded-lg shadow-md transition-all hover:translate-y-[-2px] flex items-center gap-2 min-w-[120px] justify-center mx-auto"
          >
            <span>Share on Social Media</span>
            <v-icon class="ml-2">mdi-share</v-icon>
          </button>
        </div>
      </div>
    </Motion>
  </template>
  
  <script setup lang="ts">
  import { Motion } from 'motion-v';
  
  // Define props and emits
  defineProps({
    cruise: {
      type: Object,
      default: () => ({})
    }
  });
  
  defineEmits(['share']);
  </script>
  
  <style scoped>
  /* Button animation enhancements */
  .bg-yellow-500.hover\:bg-yellow-600 {
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }
  
  .bg-yellow-500.hover\:bg-yellow-600:hover {
    transform: translateY(-2px) scale(1.03);
    box-shadow: 0 10px 25px -5px rgba(234, 179, 8, 0.4), 0 8px 10px -6px rgba(234, 179, 8, 0.2);
  }
  </style>